var React = require('react');

function Share (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2"},[React.createElement("path",{"d":"M8.545 10.823l-.434-.434a3 3 0 0 1 0-4.243l3.535-3.535a3 3 0 0 1 4.243 4.243l-3.617 3.616","key":0}),React.createElement("path",{"d":"M9.455 8.177l.434.434a3 3 0 0 1 0 4.243l-3.535 3.535a3 3 0 0 1-4.243-4.243L5.728 8.53","key":1})]));
}

Share.defaultProps = {"width":"18","height":"19","viewBox":"0 0 18 19"};

module.exports = Share;

Share.default = Share;
